import { render, staticRenderFns } from "./factBlock.vue?vue&type=template&id=53fd0544&"
import script from "./factBlock.vue?vue&type=script&lang=js&"
export * from "./factBlock.vue?vue&type=script&lang=js&"
import style0 from "./factBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports